<template>
  <div class="menu_container">
    <div class="headLine">设备资产管理系统</div>
    <!-- 菜单容器 -->
    <div class="menuBox">
      <div class="boxList box01" @click="scanCode()">
        <img src="./img/scan.png" alt="扫一扫">
        <p>扫一扫</p>
      </div>
      <div class="boxList box02" @click="deviceSearch()">
        <img src="./img/deviceSearch.png" alt="设备查询">
        <p>设备查询</p>
      </div>
      <div class="boxList box03" @click="createorder()">
        <img src="./img/createOrder.png" alt="创建工单">
        <p>创建工单</p>
      </div>
      <div class="boxList box04" @click="orderQuery()">
        <img src="./img/orderSearch.png" alt="工单查询">
        <p>工单查询</p>
      </div>
      <div class="boxList box05" @click="orderPage()">
        <img src="./img/myOrder.png" alt="我的工单">
        <p>我的工单</p>
      </div>
      <div class="boxList box06" @click="historyOrder()">
        <img src="./img/historyOrder.png" alt="提醒记录">
        <p>提醒记录</p>
      </div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
export default {
  data() {
    return{
      popstateLock: 0,//是否监听物理返回键
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //把导航路由辨别码转成整形
      if (!this.id) {
        //在没有传id的情况下，就是在系统首页，这个时候调用微信WeixinJSBridgeReady自带的API对返回键进行监听实现在首页返回关闭页面
        document.addEventListener("WeixinJSBridgeReady", function() {
          window.WeixinJSBridge.call("closeWindow");
        }, false);
        window.WeixinJSBridge.call("closeWindow");
      } else {
        //判断物理返回键是否监听
        if (!this.popstateLock) {
          window.history.pushState(null, null, '#')
        }
      }
    },
    // 扫一扫
    scanCode () {
      // 获取jsapi_ticket
      this.$http
          .get("/wechat/sign/url", {
            params: {
              // 这里是当前页面的url（本页面的域名必须与公众号js安全域名一致），一定要 location.href 获取，不然签名会无效。
              url: location.href
            }
          })
          .then(function (res) {
            // 通过config接口注入权限验证配置
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名
              jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
            });

            //通过ready接口处理成功验证
            wx.ready(function () {
              // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
              // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
              wx.checkJsApi({
                // 判断当前客户端版本是否支持指定JS接口
                jsApiList: ["scanQRCode"],
                success: function (res) {
                  // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
                  if (res.checkResult.scanQRCode === true) {
                    wx.scanQRCode({
                      // 微信扫一扫接口
                      desc: "扫描设备二维码",
                      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                      scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                      success: function (res) {
                        let scanResult = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                        window.location.href = scanResult;
                      }
                    });
                  } else {
                    alert("抱歉，当前客户端版本不支持扫一扫");
                  }
                },
                fail: function (res) {
                  // 检测getNetworkType该功能失败时处理
                  alert("检测失败" + res);
                }
              });
            });
          })
          .catch(function (error) {
            alert("扫码失败" + error);
          });
    },
    // 设备查询
    deviceSearch() {
      this.$router.push({ name: 'numbersearch', query: {type: 1} });
    },
    // 创建工单
    createorder() {
      this.$router.push({ name: 'deviceobject' });
    },
    // 工单查询
    orderQuery() {
      this.$router.push({ name: 'orderquery', query: {myOrderType: 4} });
    },
    // 我的工单
    orderPage() {
      this.$router.push({ name: 'myorder' });
    },
    // 提醒记录
    historyOrder() {
      this.$router.push({ name: 'remindrecord' });
    },
  },
}
</script>

<style lang="scss" scoped>
.menu_container {
  font-size: 16px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
  }
  .menuBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 70px 20px 20px;
    .boxList {
      display: flex;
      flex-direction: column;
      width: 45%;
      border-radius: 6px;
      text-align: center;
      margin-bottom: 20px;
      padding: 0 0 25px;
      position: relative;
      img {
        margin: 20px auto;
        height: 60px;
      }
      p {
        display: block;
        color: #F3F8F3;
        padding: 0;
        margin: 0;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .box01 {
      background-color: #36AB60;
    }
    .box02 {
      background-color: #E98F36;
    }
    .box03 {
      background-color: #D81E06;
    }
    .box04 {
      background-color: #A4579D;
    }
    .box05 {
      background-color: #1195DB;
      margin: 0;
    }
    .box06 {
      background-color: #d0c605;
      margin: 0;
    }
  }
}
</style>
